// @flow
import * as React from "react";

import { Switch, Route } from "react-router-dom";

import Loading from "views/components/Loading";

import GuestRoute from "views/utils/hoc/GuestRoute";
import PrivateRoute from "views/utils/hoc/PrivateRoute";

const Login = React.lazy(() => import("views/pages/Login"));
const Signup = React.lazy(() => import("views/pages/Signup"));

const EmailConfirmation = React.lazy(() => import("views/pages/EmailConfirmation"));
const ForgotPassword = React.lazy(() => import("views/pages/ForgotPassword"));
const ResetPassword = React.lazy(() => import("views/pages/ResetPassword"));
const SetPassword = React.lazy(() => import("views/pages/SetPassword"));

const OfferPreview = React.lazy(() => import("screens/OfferPreview"));

const LoginAsAffiliate = React.lazy(() => import("screens/LoginAsAffiliate"));

const Main = React.lazy(() => import("./Main"));

function Container(): React.Node {
  return (
    <div className="container-fluid py-2">
      <React.Suspense fallback={<Loading />}>
        <Switch>
          <GuestRoute path="/login" component={Login} />
          <GuestRoute path="/signup" component={Signup} />
          <GuestRoute path="/email-confirmation/:token" component={EmailConfirmation} />
          <GuestRoute path="/forgot-password" component={ForgotPassword} />
          <GuestRoute path="/reset-password/:token" component={ResetPassword} />
          <GuestRoute path="/set-password/:token" component={SetPassword} />

          <Route path="/offer-previews/:id" component={OfferPreview} />

          <PrivateRoute path="/login-as-affiliate/:id" component={LoginAsAffiliate} />
          <PrivateRoute component={Main} />
        </Switch>
      </React.Suspense>
    </div>
  );
}

export default Container;
